import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ENUM_PROCUREMENT_STATUS, ProcurementType } from 'models/procurement.model';

import CompleteRequestModal from 'components/modals/complete-request-modal';
const ProcurementItemMenu = ({
  status,
  ids,
  requestId,
  onCompleted,
  procurement
}: {
  status: ENUM_PROCUREMENT_STATUS;
  ids: string;
  requestId: string;
  procurement: ProcurementType;
  onCompleted?: (completedIds: string[]) => void;
}) => {
  const [showCompleteModal, setShowCompleteModal] = useState(false);
  const navigate = useNavigate();

  const receiveItem = (ids: string) => {
    navigate(`/main-store/procurement/update/receive-items/${ids}`);
  };

  const closeRequest = async () => {
    setShowCompleteModal(true);
  };

  const returnItem = (ids: string) => {
    navigate(`/main-store/procurement/update/return-items/${ids}`);
  };

  const menuOptions: Partial<
    Record<ENUM_PROCUREMENT_STATUS, { label: string; onClick: (arg0: string) => void }[]>
  > = {
    [ENUM_PROCUREMENT_STATUS.RECEIVED]: [
      {
        label: 'Return Item',
        onClick: returnItem
      },
      {
        label: 'Complete Request',
        onClick: closeRequest
      },
      {
        label: 'Receive Item',
        onClick: receiveItem
      }
    ],
    [ENUM_PROCUREMENT_STATUS.COMPLETED]: [
      {
        label: 'Return Item',
        onClick: returnItem
      }
    ],
    [ENUM_PROCUREMENT_STATUS.APPROVED]: [
      {
        label: 'Receive Item',
        onClick: receiveItem
      },
      {
        label: 'Complete Request',
        onClick: closeRequest
      }
    ],
    [ENUM_PROCUREMENT_STATUS.REQUESTED]: [
      {
        label: 'Receive Item',
        onClick: receiveItem
      },
      {
        label: 'Complete Request',
        onClick: closeRequest
      }
    ]
  };

  return (
    <div className='flex gap-2'>
      {procurement.status !== ENUM_PROCUREMENT_STATUS.REQUESTED &&
        menuOptions[status]?.map((item, index) => (
          <button
            key={index}
            className='w-fit text-xs px-4 py-2 bg-red-5 text-white rounded-md'
            onClick={() => item.onClick(ids)}>
            {item.label}
          </button>
        ))}

      <CompleteRequestModal
        isOpen={showCompleteModal}
        id={ids.split(',').filter(Boolean)}
        requestId={requestId}
        onRequestClose={() => setShowCompleteModal(false)}
        onSuccess={(completed) => {
          onCompleted?.(completed);
        }}
      />
    </div>
  );
};

export default ProcurementItemMenu;
